module.exports = __webpack_public_path__ + "img/gesture_good.e28537fc.png";